export const configProd = {
  apiKey: process.env.VUE_APP_REALTE_PROD_API_KEY,
  authDomain: process.env.VUE_APP_REALTE_PROD_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_REALTE_PROD_DATABASEURL,
  projectId: process.env.VUE_APP_REALTE_PROD_PROJECTID,
  storageBucket: process.env.VUE_APP_REALTE_PROD_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_REALTE_PROD_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_REALTE_PROD_APPID,
  measurementId: process.env.VUE_APP_REALTE_PROD_MEASUREMENTID,
  FUNCTIONS_URL: process.env.VUE_APP_REALTE_PROD_FUNCTIONS_URL
}

export const configDev = {
  apiKey: process.env.VUE_APP_REALTE_DEV_API_KEY,
  authDomain: process.env.VUE_APP_REALTE_DEV_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_REALTE_DEV_DATABASEURL,
  projectId: process.env.VUE_APP_REALTE_DEV_PROJECTID,
  storageBucket: process.env.VUE_APP_REALTE_DEV_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_REALTE_DEV_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_REALTE_DEV_APPID,
  measurementId: process.env.VUE_APP_REALTE_DEV_MEASUREMENTID,
  FUNCTIONS_URL: process.env.VUE_APP_REALTE_DEV_FUNCTIONS_URL
}

export const configGvisionProd = {
  apiKey: process.env.VUE_APP_GV_PROD_API_KEY,
  authDomain: process.env.VUE_APP_GV_PROD_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_GV_PROD_DATABASEURL,
  projectId: process.env.VUE_APP_GV_PROD_PROJECTID,
  storageBucket: process.env.VUE_APP_GV_PROD_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_GV_PROD_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_GV_PROD_APPID,
  measurementId: process.env.VUE_APP_GV_PROD_MEASUREMENTID,
  FUNCTIONS_URL: process.env.VUE_APP_GV_PROD_FUNCTIONS_URL
}

export const configGvisionDev = {
  apiKey: process.env.VUE_APP_GV_DEV_API_KEY,
  authDomain: process.env.VUE_APP_GV_DEV_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_GV_DEV_DATABASEURL,
  projectId: process.env.VUE_APP_GV_DEV_PROJECTID,
  storageBucket: process.env.VUE_APP_GV_DEV_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_GV_DEV_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_GV_DEV_APPID,
  measurementId: process.env.VUE_APP_GV_DEV_MEASUREMENTID,
  FUNCTIONS_URL: process.env.VUE_APP_GV_DEV_FUNCTIONS_URL
}
